import styled from 'styled-components';

const TableBody = styled.tbody.attrs({ role: 'rowgroup' })`
  display: table-row-group;
`;

export default TableBody;
